import { ChangeEvent } from 'react'
import classNames from 'classnames'
import { IEventData, IErrors } from 'interface/calendar'

interface IEventDescriptionInputProps {
  eventData: IEventData;
  setEventData: React.Dispatch<React.SetStateAction<IEventData>>;
  errors: IErrors;
  setErrors: React.Dispatch<React.SetStateAction<IErrors>>;
}

export const EventDescriptionInput: React.FC<IEventDescriptionInputProps> = ({
  eventData,
  setEventData,
  errors,
  setErrors
}) => {
  const handleChangeDescription = (evt: ChangeEvent<HTMLTextAreaElement>) => {
    setEventData((prevData) => ({
      ...prevData,
      description: evt.target.value,
    }))
    setErrors({
      ...errors,
      description: [],
    })
  }

  return (
    <div>
      <p className="font-inter text-sm font-normal leading-4 text-dark-gray-100">
        Description
      </p>
      <textarea
        className={classNames(
          'w-full h-[80px] resize-y border rounded-lg mt-1 text-sm leading-4 placeholder-[#A9A9A9] text-[#111827] px-3 py-2 focus-visible:outline-none',
          errors.description?.length ? 'text-red-600 border-red-500' : ''
        )}
        placeholder="Enter event description here"
        value={eventData.description}
        onChange={handleChangeDescription}
      />
      {errors.description?.map((error, index) => (
        <p key={index} className="mb-1 text-xs text-red-600 dark:text-red-500">
          {error}
        </p>
      ))}
    </div>
  )
}
